import { r as registerInstance, h, F as Fragment } from './index-16dc7dde.js';
import './product-card-6bb8cb81.js';
import { s as store } from './pes-router-store-1a105b49.js';
import './store-9d26336f.js';
import './utils-15ad90ec.js';
import { g as getFilteredBreadcrumbs } from './utils-400179ea.js';
import { a as addHostToHmcUrls } from './utils-14261011.js';
import './pick-bfea8c03.js';
import './_basePickBy-9e484e47.js';
import './identity-6651b537.js';
import './isTypedArray-dfccd669.js';
import './isObject-33fa1780.js';
import './_commonjsHelpers-ba3f0406.js';
import './isSymbol-45bfef0c.js';
import './toString-da636857.js';
import './_assignValue-8e900715.js';
import './_isIndex-af307327.js';
import './hasIn-6ce0da41.js';
import './_flatRest-49cdf089.js';
import './_baseFlatten-2670ede5.js';
import './index-136476ff.js';
import './request.constants-deb285e0.js';
import './lookups-705fb53e.js';
import './analytics-765d4daf.js';
import './send-33ade633.js';
import './utils-913bdf8a.js';
import './pes-product-link-b5153381.js';
import './utils-e67addce.js';
import './isEmpty-b60327cb.js';
import './utils-2361a8f1.js';
import './index-634d378a.js';
import './tslib.es6-2af8cb53.js';
import './toNumber-5000b45d.js';
import './currency-b61904e0.js';
import './parsers-e38ff6a5.js';

const pesAppSubcategoryListingCss = ".subcategories__listing__main{background-color:#fafafa}";

let PesAppSubcategoryListing = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.subcategoryData = null;
    this.showDocuments = true;
    this.enableCommerceConnector = true;
    this.showBuyOnline = true;
    this.showCompare = true;
  }
  componentWillRender() {
    store.set('enableAppRouting', true);
  }
  get customBreadcrumbs() {
    if (!this.showBreadcrumbs) {
      return null;
    }
    return getFilteredBreadcrumbs(this.subcategoryData.subcategoryBreadcrumbs.breadcrumbs);
  }
  get hmcBanner() {
    var _a, _b;
    if (!((_b = (_a = this.subcategoryData) === null || _a === void 0 ? void 0 : _a.subcategoryListingRanges) === null || _b === void 0 ? void 0 : _b.hmcBanner)) {
      return null;
    }
    const { hmcBanner } = this.subcategoryData.subcategoryListingRanges;
    addHostToHmcUrls(this.host, hmcBanner);
    return hmcBanner;
  }
  render() {
    const { subcategoryBreadcrumbs: { hideOnMobile }, subcategoryDescription: { name, description, readLessLabel, readMoreLabel }, subcategoryListingRanges: { localeCode, productsUrl, hideHMCBanner = false, subcategorySection, productsSection, filtersSection, navigationState, filtersUrl, rangesUrl, numberOfProducts, hiddenSubcategoriesInfo, pageParam, }, } = this.subcategoryData;
    return (h(Fragment, null, h("div", { class: "subcategories__listing__main" }, this.showBreadcrumbs && (h("pes-breadcrumbs", { breadcrumbs: this.customBreadcrumbs, hideOnMobile: hideOnMobile })), h("header", null, h("pes-category-description", { name: name, description: description, readMoreLabel: readMoreLabel, readLessLabel: readLessLabel })), h("main", null, h("pes-category-subcategory-listing", { host: this.host, localeCode: localeCode, subcategorySection: subcategorySection, productsSection: productsSection, filtersSection: filtersSection, hmcBanner: this.hmcBanner, hideHMCBanner: hideHMCBanner, navigationState: navigationState, filtersUrl: filtersUrl, productsUrl: productsUrl, rangesUrl: rangesUrl, numberOfProducts: numberOfProducts, showDocuments: this.showDocuments, showBuyOnline: this.showBuyOnline, showCompare: this.showCompare, enableCommerceConnector: this.enableCommerceConnector, avoidAccents: false, hiddenSubcategoriesInfo: hiddenSubcategoriesInfo, pageParam: pageParam, isPBS: true, isSubcategoryPage: true, productCtas: this.productCtas }), h("pes-products-carousel", Object.assign({}, this.recentlyViewedProducts, { class: "pes-app-subcategory__section" }))))));
  }
};
PesAppSubcategoryListing.style = pesAppSubcategoryListingCss;

export { PesAppSubcategoryListing as pes_app_subcategory_listing };
